<template>
  <component
      :class="[
      'd-flex maxw-100 flex-column gmb-display-cell',
      { 'p-2 shadow-volume rounded-1 bg-theme-2': !noBackground },
    ]"
      :href="href"
      :is="tagType"
      target="_blank"
  >
    <div
        v-if="
        (isValidState && stateIndicator) ||
        pictofAPictoCssClasses ||
        title ||
        subTitle
      "
        class="d-flex align-items-center"
    >
      <div
          v-if="isValidState && stateIndicator"
          :class="[
          'd-flex m-1 p-2 justify-content-center align-items-center rounded-circle gmb-display-cell__wrapper',
          stateSpecificWrapperCssClass,
        ]"
      >
        <div class="d-flex rounded-circle gmb-display-cell__indicator"/>
      </div>

      <FdText v-if="pictofAPictoCssClasses" class="m-1" fa fontSizeBigger4>
        <i :class="pictofAPictoCssClasses"/>
      </FdText>

      <div class="d-flex m-1 flex-grow-1 w-0 flex-column">
        <FdText v-if="title" tag="span">{{ title }}</FdText>
        <FdText v-if="subTitle" colorLightGrey fontSizeSmaller3 tag="span">{{
            subTitle
          }}
        </FdText>
      </div>
    </div>

    <div v-if="value" :class="['d-flex align-items-center', { 'm-1': title }]">
      <div
          :class="[
          'd-flex',
          {
            'border py-1 px-2 rounded-1 gmb-display-cell__wrapper':
              isValidState,
          },
          stateSpecificWrapperCssClass,
        ]"
      >
        <FdText fontSizeBigger4 tag="span">{{ value }}</FdText>
      </div>

      <div v-if="unity || subUnity" class="d-flex m-1 flex-column">
        <FdText v-if="unity" colorLightGrey tag="span">{{ unity }}</FdText>
        <FdText v-if="subUnity" colorLightGrey fontSizeSmaller3 tag="span">{{
            subUnity
          }}
        </FdText>
      </div>
    </div>

    <FdText
        v-if="comment"
        class="m-1"
        colorLightGrey
        fontSizeSmaller5
        italic
        tag="span"
    >{{ comment }} Lorem ipsum dolor, sit amet consectetur adipisicing elit.
      Reiciendis et ipsa animi eos at. Quod.
    </FdText>
  </component>
</template>

<script>
import {hasEnrichedSlot} from "@/helpers.js";

import FdText from "@/flexdesign/Text";

export default {
  name: "GmbDisplayCell",

  components: {FdText},

  props: {
    comment: String,
    href: String,
    noBackground: Boolean,
    pictofAPictoCssClasses: String,
    subTitle: String,
    subUnity: String,
    state: String,
    stateIndicator: Boolean,
    title: String,
    unity: String,
    value: [Number, String],
  },

  data() {
    return {
      states: {
        alert: "alert",
        danger: "danger",
        neutral: "neutral",
        success: "success",
      },
    };
  },

  computed: {
    hasPicto() {
      return hasEnrichedSlot(this, "picto");
    },

    isValidState() {
      if (!this.state) return false;

      for (const [key, value] of Object.entries(this.states)) return true;

      return false;
    },

    stateSpecificWrapperCssClass() {
      let cssClass = undefined;

      if (this.state)
        switch (this.state) {
          case this.states.alert:
            cssClass = "gmb-display-cell__wrapper--alert";
            break;

          case this.states.danger:
            cssClass = "gmb-display-cell__wrapper--danger";
            break;

          case this.states.neutral:
            cssClass = "gmb-display-cell__wrapper--neutral";
            break;

          case this.states.success:
            cssClass = "gmb-display-cell__wrapper--success";
            break;
        }

      return cssClass;
    },

    tagType() {
      return this.href ? "a" : "div";
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/dimensions";
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/mixins";
@import "@/../node_modules/bootstrap/scss/variables";
@import "@/../node_modules/bootstrap/scss/utilities/spacing";

.gmb-display-cell {
  width: $gmb-cell-width;

  &__wrapper {
    &--alert {
      background-color: rgba($gmb-color-alert, 0.2);

      &.border {
        border-color: $gmb-color-alert !important;
      }

      & > .gmb-display-cell__indicator {
        background-color: $gmb-color-alert;
      }
    }

    &--danger {
      background-color: rgba($gmb-color-danger, 0.2);

      &.border {
        border-color: $gmb-color-danger !important;
      }

      & > .gmb-display-cell__indicator {
        background-color: $gmb-color-danger;
      }
    }

    &--neutral {
      background-color: rgba($gmb-color-neutral, 0.2);

      &.border {
        border-color: $gmb-color-neutral !important;
      }

      & > .gmb-display-cell__indicator {
        background-color: $gmb-color-neutral;
      }
    }

    &--success {
      background-color: rgba($gmb-color-success, 0.2);

      &.border {
        border-color: $gmb-color-success !important;
      }

      & > .gmb-display-cell__indicator {
        background-color: $gmb-color-success;
      }
    }
  }

  &__indicator {
    width: calc(2 * #{$spacer} * 0.5);
    height: calc(2 * #{$spacer} * 0.5);
  }
}

a.gmb-display-cell {
  color: unset;

  &:hover {
    text-decoration: none;
    color: unset;
  }
}
</style>
